import { api } from '@/config'
import httpApi from '@/util/http-api'

export default {
  getEmploymentTypes: () => {
    return httpApi.getDataViaApi(api.employmentTypes)
  }
}
